<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>

<!--    <div class="border border-blue-900   py-3 px-4 rounded-top rounded-bottom" style="background-color: #bde2ef">-->
<!--      <p class="" style="font-size: 15px">-->
<!--        Poichè il sito pvp.giustizia.it è stato completamente rinnovato, i link degli immobili in asta presenti nell'archivio <strong>non sono più attivi</strong>.-->
<!--        <br>-->

<!--      </p>-->

<!--    </div>-->




    <div  class="card abtg__default-card abtg__orangeborder-bottom">
      <div class="card-body abtg__table-border">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Categoria*</label>
                  <multiselect :options="categoriesList" track-by="nome" label="nome"
                               :placeholder="''"
                               :preserve-search="true" :class="'abtg__multiselect-form-control'"
                               :selectLabel="'Clicca per selezionare'" :selectedLabel="'Selezionato'"
                               :deselectLabel="'Clicca per rimuovere'" v-model="formData.category"
                               :searchable="true" :close-on-select="true"
                               @input="setTypologies({categoryId: formData.category.id})">
                    <template slot="noResult">
                      Nessun Risultato.
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Tipologia</label>
                  <multiselect :options="typologiesList" track-by="nome" label="nome"
                               :placeholder="''"
                               :preserve-search="true" :class="'abtg__multiselect-form-control'"
                               :selectLabel="'Clicca per selezionare'" :selectedLabel="'Selezionato'"
                               :deselectLabel="'Clicca per rimuovere'" v-model="formData.typology"
                               :searchable="true" :close-on-select="false" :multiple="true"
                               :clear-on-select="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                                                {{ values.length }}
                                                <span v-if="values.length ===1 ">tipologia selezionata</span>
                                                <span v-else>tipologie selezionate</span>
                                            </span>
                    </template>

                    <template slot="noResult"> Nessun Risultato.</template>
                  </multiselect>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Tribunale</label>
                  <multiselect
                      :options="tribunalsList"
                      track-by="nome"
                      label="nome"
                      :placeholder="''"
                      :preserve-search="true"
                      :class="'abtg__multiselect-form-control'"
                      :selectLabel="'Clicca per selezionare'"
                      :selectedLabel="'Selezionato'"
                      :deselectLabel="'Clicca per rimuovere'"
                      v-model="formData.tribunal"
                      :searchable="true"
                      :close-on-select="true"
                  >
                    <template slot="noResult"> Nessun Risultato.</template>
                  </multiselect>
                </div>
              </div>
<!--              <div class="col-lg-3">-->
<!--                <div class="form-group">-->
<!--                  <label>Comune</label>-->
<!--                  <input-->
<!--                      type="text"-->
<!--                      v-model="formData.city"-->
<!--                      class="form-control abtg_auction-input-box"-->
<!--                      name="city"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>RGE/ANNO (coming soon)</label>
                  <input
                      readonly
                      type="text"
                      v-model="formData.rge_year"
                      class="form-control abtg_auction-input-box"
                      name="rge_year"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>Indirizzo</label>
                  <input
                      type="text"
                      v-model="location.address"
                      class="form-control abtg_auction-input-box"
                      name="address"
                      id="autocomplete"
                      @focus="geolocate()"
                  />
                </div>
              </div>

            </div>

            <div class="row pt-4">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>Base d'asta</label>
                  <vue-slider
                      v-model="rangeValue"
                      :process="processStyle"
                      :dotOptions="dotOption"
                      :min="0"
                      :max="1000000"
                      :interval="100"
                      :tooltip="'always'"
                      :tooltip-placement="'bottom'"
                      :tooltip-formatter="currencyFormatter"
                  >
                  </vue-slider>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>Raggio d'azione</label>
                  <vue-slider
                      v-model="radiusValue"
                      :process="processStyleRadius"
                      :dotOptions="dotOption"
                      :min="0"
                      :max="50"
                      :interval="1"
                      :tooltip="'always'"
                      :tooltip-placement="'bottom'"
                  >
                  </vue-slider>
                </div>
              </div>
            </div>

            <div class="row" v-if="1 === 2">
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Data di pubblicazione - inizio</label>
                  <date-picker
                      v-model="formData.publish_date_start"
                      lang="it"
                      placeholder=""
                      format="DD/MM/YYYY"
                  ></date-picker>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Data di pubblicazione - fine</label>
                  <date-picker
                      v-model="formData.publish_date_end"
                      lang="it"
                      placeholder=""
                      format="DD/MM/YYYY"
                  ></date-picker>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Data di vendita - inizio</label>
                  <date-picker
                      v-model="formData.sold_date_start"
                      lang="it"
                      placeholder=""
                      format="DD/MM/YYYY"
                  ></date-picker>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <label>Data di vendita - fine</label>
                  <date-picker
                      v-model="formData.sold_date_end"
                      lang="it"
                      placeholder=""
                      format="DD/MM/YYYY"
                  ></date-picker>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <button
                    type="button"
                    class="
                    btn
                    pull-right
                    shadow-none
                    abtg__btn-tool abtg__btn-third
                  "
                    @click="setFilters(1)"
                >
                  Cerca
                  <i class="fas fa-sync-alt fa-spin" v-if="showLoading"></i>
                </button>


              </div>
              <hr v-if="showMoreBtn || allSearched" style="width:100%;text-align:left;margin-left:0"/>
              <div class="col-lg-12 text-end">
                <button
                    v-if="showMoreBtn"
                    type="button"
                    class="
                    btn

                    pull-right
                    shadow-none
                    abtg__default-button
                    abtg__btn-more


                  "
                    @click="setFilters(index+1)"
                >
                  Cerca di più (con questi filtri)
                  <i class="fas fa-sync-alt fa-spin" v-if="showLoading"></i>
                </button>
                <p v-if="allSearched" class="abtg__alert-danger"> Non ci sono altri immobili per i filtri
                  selezionati</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="table-responsive">
              <div style="margin-top: 30px" v-if="showLoading">
                <hr/>
                <p class="text-center">
                  <i
                      class="fas fa-sync fa-spin fa-3x"
                      style="color: #ef7621"
                  ></i>
                </p>
                <p class="text-center">Sto cercando</p>
              </div>
              <div v-else>
                <hr/>
              </div>


              <table
                  v-if="buildingList.data &&  buildingList.data.length > 0"
                  class="
                  mdl-data-table
                  ml-table-striped ml-table-bordered
                  mdl-js-data-table
                  is-upgraded
                  abtg__auction_table_td
                "
              >
                <thead>
                <tr>
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Tribunale
                  </th>
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    RGE/ANNO
                  </th>

                  <!--                                <th class="mdl-data-table__cell&#45;&#45;non-numeric text-left">#Lotto</th>-->
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Data pubblicazione
                  </th>
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Indirizzo
                  </th>
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Data Vendita
                    <i
                        class="fas fa-sort-amount-up abtg__label-color-custom"
                        @click="handlingSort('date')"
                        v-show="sortDate === true"
                    ></i>
                    <i
                        class="fas fa-sort-amount-down abtg__label-color-custom"
                        @click="handlingSort('date')"
                        v-show="sortDate === false"
                    ></i>
                  </th>
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Base d'asta
                    <i
                        class="fas fa-sort-amount-up abtg__label-color-custom"
                        @click="handlingSort('baseAuction')"
                        v-show="sortBaseAuction === false"
                    ></i>
                    <i
                        class="fas fa-sort-amount-down abtg__label-color-custom"
                        @click="handlingSort('baseAuction')"
                        v-show="sortBaseAuction === true"
                    ></i>
                  </th>

                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Offerta min.
                  </th>
                  <th class="mdl-data-table__cell--non-numeric text-left">
                    Rialzo min.
                  </th>
                  <!--                                <th class="mdl-data-table__cell&#45;&#45;non-numeric text-left">Mq</th>-->

                  <th class="mdl-data-table__cell--non-numeric text-center">
                    <input type="checkbox" @click="selectAll"/>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(building, index) in buildingList.data">
                  <td style="white-space: normal">

                    {{building.tribunale}}
                  </td>
                  <td style="white-space: normal">
                      {{building.procedura}}
                  </td>
                  <!--                                <td style="white-space: normal;">-->
                  <!--                                    {{building.dettaglio_procedura['lotto_nr.']}}-->
                  <!--                                </td>-->
                  <td style="white-space: normal">
                    {{building.dataPubblicazione}}
                  </td>
                  <td style="white-space: normal">
                    <a :href="'https://pvp.giustizia.it/pvp/it/detail_annuncio.page?idAnnuncio=' + building.id"
                       target="_blank">
                    {{building.indirizzo.via}}, {{building.indirizzo.numeroCivico}} - {{building.indirizzo.cap}} {{building.indirizzo.citta}} ({{building.indirizzo.provincia}})
                  </a>
                  </td>
                  <td style="white-space: normal">
                    {{building.dataVendita}}
                  </td>
                  <td>
                    <i class="fas fa-euro-sign"></i>
                      {{building.prezzoBaseAsta}}
                  </td>

                  <td>
                    <i class="fas fa-euro-sign"></i>
                    {{building.offertaMinima}}
                  </td>

                  <td>
                    <i class="fas fa-euro-sign"></i>
                    {{building.rialzoMinimo}}
                  </td>
                  <!--                                <td style="white-space: normal;">{{building.beni_lotto[0].superficie}}</td>-->

                  <td style="white-space: normal">
                    <div class="btn-group" role="group">
                      <input
                          type="checkbox"
                          :value="building.id"
                          v-model="checkedBuildings"
                      />
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer">

        <h3 class="text-center" v-if="showMessageImportCompleted">
          Gli immobili sono stati importati:
          <a href="/auction/">vai all'archivio aste per gestirli</a>.
        </h3>

        <div class="float-right" v-if="!showMessageImportCompleted">
          <div>
            <p v-if="allSearched" class="abtg__alert-danger_b px-2"> Non ci sono altri immobili per i filtri
              selezionati</p>


          </div>
          <button
              v-if="showMoreBtn"
              type="button"
              class="
                    btn

                    pull-right
                    shadow-none
                    abtg__default-button
                    abtg__btn-more


                  "
              @click="setFilters(index+1)"
          >
            Cerca di più (con questi filtri)
            <i class="fas fa-sync-alt fa-spin" v-if="showLoading"></i>
          </button>


          <button
              type="submit"
              v-if="showImportBtn"
              class="
              btn btn-block
              abtg__default-button
              m-t-20
              abtg__btn-star
              shadow-none
            "
              @click.prevent="setImportData()"
              style="font-size: 100%"
          >
            Importa aste
          </button>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import {mixin} from "@/helpers/helper";
import {Money} from "v-money";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import NBread from "@/partials/bread";
import {mapActions, mapState, mapMutations, mapGetters} from "vuex";

let placeSearch, autocomplete;

export default {
  components: {
    DatePicker,
    Money,
    NBread,
    VueSlider,
    multiselect,
  },
  data: function () {
    return {
      sortBaseAuction: false,
      sortDate: false,
      priorityDate: false,
      priorityBaseAuction: false,
      isAllSelected: false,
      rangeValue: [0, 200000],
      radiusValue: 25,
      checkedBuildings: [],
      index: 1,
      dirDesc: true,

      currencyFormatter: (v) =>
          ("€ " + v).replace(/\B(?=(\d{3})+(?!\d))/g, "."),
      processStyle: (dotsPos) => [
        [dotsPos[0], dotsPos[1], {backgroundColor: "#EF7B10"}],
      ],
      processStyleRadius: (dotsPos) => [
        [0, dotsPos[0], {backgroundColor: "#EF7B10"}],
      ],
      dotOption: {
        style: {backgroundColor: "#EF7B10", borderColor: "#EF7B10"},
        focusStyle: {boxShadow: "0 0 0 5px rgba(239, 123, 16, 0.2)"},
      },
      location: [],
    };
  },
  mixins: [mixin],

  created: function () {
    this.trackActivity();
    this.SET_DATA({name: "bread_active", data: {label: "Aste"}});
    this.initAuctionMapping();
  },
  mounted() {
    setTimeout(() => {
      this.initAutocomplete();
    }, 500);
  },
  computed: {
    ...mapState("n_auction", [
      "showMessageImportCompleted",
      "categoriesList",
      "tribunalsList",
      "typologiesList",
      "buildingList",
      "showLoading",
      "showImportBtn",
      "showMoreBtn",
      "bread_list",
      "bread_active",
      "formData",
      'allSearched'
    ]),
    filteredList() {
      return this.buildingList.data;
      // if (this.filteredData) {
      //   return this.filteredData.sort((a, b) => {
      //     if (this.priorityBaseAuction === true) {
      //       let baseA = a.dettaglio_vendita["prezzo_base_d'asta"]
      //           .replace(/\./g, "")
      //           .replace(/\,/g, ".");
      //       let baseB = b.dettaglio_vendita["prezzo_base_d'asta"]
      //           .replace(/\./g, "")
      //           .replace(/\,/g, ".");
      //       return this.sortBaseAuction === true
      //           ? baseB - baseA
      //           : baseA - baseB;
      //     }
      //
      //     if (this.priorityDate === true) {
      //       let dateA = new Date(
      //           a.dettaglio_vendita.data_di_vendita.substr(0, 10)
      //       ).getTime();
      //       let dateB = new Date(
      //           b.dettaglio_vendita.data_di_vendita.substr(0, 10)
      //       ).getTime();
      //       return this.sortDate === true && dateA > dateB ? 1 : -1;
      //     }
      //   });
      // }
    },
  },
  methods: {
    ...mapActions("n_auction", [
      "initAuctionMapping",
      "setTypologies",
      "sendSearchFilters",
      "importData",
    ]),
    ...mapMutations("n_auction", ["SET_DATA"]),


    setFilters: function (x) {

      this.index = x;
      this.SET_DATA({name: "showLoading", data: true});
      this.sendSearchFilters({
        range: this.rangeValue,
        radiusValue: this.radiusValue,
        location: this.location,
        index: this.index
      });
    },
    trackActivity() {
      axios.get('/api/v2/trackactivity/track')
          .then(() => {

          })
    },

    selectAll: function () {
      let self = this;
      this.isAllSelected = !this.isAllSelected;
      if (this.isAllSelected === true) {
        this.buildingList.data.forEach(function (value) {
          self.checkedBuildings.push(value.id);
        });
      } else {
        self.checkedBuildings = [];
      }
    },

    setImportData() {
      this.importData({checkedBuildings: this.checkedBuildings});
    },

    handlingSort(sortBy) {
      this.dirDesc = !this.dirDesc;
       switch (sortBy) {
        case "baseAuction":
          this.priorityBaseAuction = true;
          this.sortBaseAuction = !this.sortBaseAuction;
          this.priorityDate = false;
          this.sortDate = false;
          if (this.dirDesc) {
            this.buildingList.data.sort((a, b) => new Date(a.prezzoBaseAsta) - new Date(b.prezzoBaseAsta));
          } else {
            this.buildingList.data.sort((a, b) => new Date(b.prezzoBaseAsta) - new Date(a.prezzoBaseAsta));
          }
          break;
        case "date":
          this.priorityDate = true;
          this.sortDate = !this.sortDate;
          this.priorityBaseAuction = false;
          this.sortBaseAuction = false;
          if (!this.dirDesc) {
            this.buildingList.data.sort((a, b) => new Date(a.dataVendita) - new Date(b.dataVendita));
          } else {
            this.buildingList.data.sort((a, b) => new Date(b.dataVendita) - new Date(a.dataVendita));
          }
          break;
      }
    },

    initAutocomplete() {
      autocomplete = new google.maps.places.Autocomplete(
          document.getElementById("autocomplete"),
          {types: ["geocode"]}
      );

      autocomplete.addListener("place_changed", this.onPlaceChanged);
    },

    onPlaceChanged() {
      let place = autocomplete.getPlace();
      this.location = {
        address: place.formatted_address,
        coordinates: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
    },

    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          autocomplete.setBounds(circle.getBounds());
        });
      }
    },
  },
};
</script>

